<template>
  <div class="lead-time-label" :class="{ 'lead-time-label--truck-view': isTruckView }">
    <IconTruck v-if="isTruckView" color="#4A4A4A" class="lead-time-label__truck-icon" />
    <div class="lead-time-label__text-block">
      <div class="lead-time-label__title-line">
        <span class="lead-time-label__title">{{ $t('leadTime.estimatedLeadTime') }}</span>
        <info-bubble-tooltip
          v-if="isTruckView && tooltipText"
          :text="tooltipText"
          color="teal"
          class="lead-time-label__icon"
        />
      </div>
      <span class="lead-time-label__value" v-html="valueText" />
    </div>
    <info-bubble-tooltip
      v-if="!isTruckView && tooltipText"
      :text="tooltipText"
      color="teal"
      class="lead-time-label__icon"
    />
  </div>
</template>
<script>
import { useContentfulComponent } from '@/components/common/contentful/composables/useContentfulComponent'
import IconTruck from '@/components/common/icons/IconTruck.vue'
import InfoBubbleTooltip from '@/components/common/InfoBubbleTooltip.vue'

export default {
  components: {
    IconTruck,
    InfoBubbleTooltip,
  },
  props: {
    value: {
      type: [Number, String, null],
      required: true,
      default: '',
    },
    isPending: {
      type: Boolean,
      default: false,
    },
    isTruckView: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { getSiteCopy } = useContentfulComponent()

    return {
      getSiteCopy,
    }
  },
  computed: {
    valueText() {
      if (this.value === null) return this.$t('leadTime.toBeDetermined')
      const valueAsNumber = parseInt(this.value)
      return valueAsNumber >= 0 && valueAsNumber < 5
        ? this.$t('leadTime.availableNow')
        : this.$t('leadTime.toBeDetermined')
    },
    tooltipText() {
      return this.getSiteCopy('copyGroupCommon', 'copyItemEstimatedLeadTimeTooltip') || ''
    },
  },
}
</script>
